import React from 'react';
import {Grid, Card, Tooltip} from '@mui/material';
import {CardMediaComponent} from '@/components/ui/card-media';
import {useTranslation} from 'react-i18next';
import {Module} from '@/types/module';

interface ModuleCardProps {
  module: Module;
  availableModules: string[];
}

const ModuleCard: React.FC<ModuleCardProps> = ({module, availableModules}) => {
  const {t, i18n} = useTranslation('health_modules');
  const label = module.label
    ? i18n.language === 'en'
      ? module.label.en
      : module.label.de
    : t(`module.${module.key}`);

  // const handleCardClick = () => {
  //   window.location.href = module.url;
  // };

  let moduleUrl: string;

  if (module.key === 'medialib') {
    const modulesParam = availableModules.join(',');
    moduleUrl = `${module.url}?modules=${modulesParam}`;
  } else {
    moduleUrl = module.url;
  }

  const handleCardClick = () => {
    window.open(moduleUrl, '_blank');
  };

  // const handleCardClick = () => {
  //   const iframe = document.createElement("iframe");
  //   iframe.src = module.url;
  //   iframe.style.width = "100%";
  //   iframe.style.height = "100%";
  //   const container = document.getElementById("iframe-container");
  //   if (container) {
  //     container.innerHTML = "";
  //     container.appendChild(iframe);
  //   }
  // };
  return (
    <Grid item xs={12}>
      <Tooltip title={t('open_module')}>
        <Card
          sx={{
            width: '100%',
            cursor: 'pointer',
            display: 'flex',
            flexDirection: {xs: 'column', md: 'row'}
          }}
          onClick={handleCardClick}
        >
          <Grid item xs={12}>
            <CardMediaComponent
              height={240}
              image={module.picture}
              altText={label}
              overlayLabel={label}
              overlayLabelSize={'h4'}
              gradient={true}
              underlineOnHover={true}
            />
          </Grid>
        </Card>
      </Tooltip>
    </Grid>
  );
};

export default ModuleCard;
